const text = "VYORA PILOT SERIES • NUR 50 LIMITIERTE TICKETS • €10 • 03.10.2026 PILOT EVENT • ZAHLUNG AM EINGANG • QR-TICKET SOFORT • WELCOME TO THE PILOT • ";

export const Marquee = () => (
  <div className="overflow-hidden border-y border-[#E5C378]/10 bg-[#E5C378]/[0.04] py-5">
    <div className="marquee-track flex whitespace-nowrap font-syne text-sm font-bold uppercase tracking-[0.24em] text-[#E5C378]/80">
      {[0, 1].map((copy) => (
        <span key={copy} className="pr-4" aria-hidden={copy === 1}>
          {text.repeat(3)}
        </span>
      ))}
    </div>
  </div>
);
